//  these should be global functions tho
export const removeClass = (element, classname) => {
  if (hasClass(element, classname)) {
    element.classList.remove(classname);
  }
};

export const addClass = (element, classname) => {
  if (!hasClass(element, classname)) {
    element.classList.add(classname);
  }
};

export const hasClass = (element, classname) => {
  return element.classList.contains(classname);
};



// WEBPACK FOOTER //
// ./scripts/util/misc.js